import { apiSelectItemList } from '@/api/item/master.js';

export function convertShopifyCustomer(customer) {
	let cust = null;
	if (customer) {
		const address = customer.defaultAddress || {};
		cust = {
			code: customer.new_code,
			partner_type: 'C',
			active_yn: 'Y',
			country: address.countryCodeV2,
			address_zipcode: address.zip,
			address_state: address.provinceCode,
			address_city: address.city,
			address_detail: address.address1 || address.address2 || '',
			address_detail2: address.address1 ? address.address2 || '' : '',
			name: address.company || customer.displayName, // Shopify Company가 name?? => 논의 예정
			owner_name: customer.displayName, // Shopify Name이 Owner Name?? => 논의 예정
			telephone: customer.phone || address.phone,
			email: customer.email,
			sales_group_code: null, // 논의 예정
		};
	}

	return cust;
}

export async function converShopifyOrderToSOForUpdate(shopify_order, basic_info) {
	const invoice = await converShopifyOrderToSOForCreate(shopify_order, basic_info);
	if (!invoice.data) {
		return {
			data: null,
			msg: invoice.msg,
		};
	}
	const original_order = shopify_order.original_order;
	invoice.data.invoice_no = original_order.invoice_no;
	invoice.data.so_dn = original_order.so_dn;
	invoice.data.item_nos_to_delete = Array.isArray(original_order.item_list) ? original_order.item_list.map(i => i.invoice_item_no) : [];

	return invoice;
}

export async function converShopifyOrderToSOForCreate(shopify_order, basic_info) {
	if (!shopify_order) {
		return {
			data: null,
			msg: "Shopify Order doesn't Exist.",
		};
	}

	// invoice_items
	const invoice_items = await converShopifyOrderItems(shopify_order.lineItems, basic_info.ship_to_code);
	if (!invoice_items.data) {
		return {
			data: null,
			msg: invoice_items.msg,
		};
	} else if (!invoice_items.data.length) {
		// 논의 예정
	}

	// invoice_shipment
	let shipment = converShopifyShipment(shopify_order);
	if (shipment.data == null) {
		// 논의 예정
		shipment.data = {};
	}

	// invoice
	const invoice = {
		invoice_type: 'S',
		status_code: shopify_order.cancelReason ? 'V' : 'O',
		so_date: shopify_order.createdAt ? shopify_order.createdAt.split('T')[0] : null,
		total_quantity: invoice_items.data.reduce((prev, curr) => prev + curr.quantity, 0),
		total_amount: invoice_items.data.reduce((prev, curr) => prev + curr.amount, 0),
		ship_to_code: basic_info.ship_to_code,
		bill_to_code: basic_info.bill_to_code,
		sales_group_code: basic_info.sales_group_code, // 논의 예정
		payment_term_code: basic_info.payment_term_code, // 논의 예정
		ship_charge_code: basic_info.ship_charge_code, // 논의 예정
		delivery_type_code: basic_info.delivery_type_code, // 논의 예정
		source: 'SHOPIFY',
		// invoice_item의 r_price에 값이 없지만, 원래 공식 그대로 적용
		total_request_amount: invoice_items.data.reduce((prev, curr) => prev + curr.quantity * (curr.r_price || curr.unit_price), 0),
		items: invoice_items.data,
		ship_to_address: shipment.data,
		remark: 'Shopify No.: ' + shopify_order.name,
		other_charge: getPresentmentMoney(shopify_order.currentTotalTaxSet),
		special_discount: getPresentmentMoney(shopify_order.currentTotalDiscountsSet) - invoice_items.data.reduce((prev, curr) => prev + curr.discount_amount, 0),
	};

	return {
		data: invoice,
	};
}

function getPresentmentMoney(priceSet) {
	return priceSet && priceSet.presentmentMoney ? Number(priceSet.presentmentMoney.amount) || 0 : 0;
}

async function converShopifyOrderItems(shopify_items, ship_to_code) {
	// invoice_items
	const invoice_items = [];
	let item_list = null;

	if (shopify_items.length > 0) {
		const param_for_items = {
			for_sale: true,
			ship_to_code: ship_to_code,
			item_codes: shopify_items.map(li => li.sku),
		};

		const { data } = await apiSelectItemList(param_for_items);
		item_list = data.itemList;
	} else {
		return {
			data: null,
			msg: 'No Items for Shopify Order.',
		};
	}

	if (item_list != null && item_list.length > 0) {
		const no_items_matching = shopify_items.filter(si => !si.sku || !item_list.some(i => si.sku.toUpperCase() === i.item_code.toUpperCase()));
		if (no_items_matching.length > 0) {
			let msg = '';
			no_items_matching.forEach(m => (msg += m.name + '(' + m.sku + ')<br />'));
			msg += 'No Items Matching Shopify Order.';
			return {
				data: null,
				msg: msg,
			};
		}

		for (const item of item_list) {
			const si_list = shopify_items.filter(si => si.sku === item.item_code);
			if (!Array.isArray(si_list) || !si_list.length) continue;

			let unit_price = 0;
			let quantity = 0;
			let discount_amount = 0;

			for (const si of si_list) {
				const temp_unit_price = getPresentmentMoney(si.discountedUnitPriceSet);
				const temp_discount_amount = getPresentmentMoney(si.totalDiscountSet);

				if (temp_unit_price) {
					if (temp_unit_price > unit_price) unit_price = temp_unit_price;
					if (!unit_price) unit_price = temp_unit_price; // 음수인 가격 고려
				}

				if (si.currentQuantity) quantity += si.currentQuantity;
				if (temp_discount_amount) discount_amount += temp_discount_amount;
			}

			if (quantity > 0) {
				invoice_items.push({
					item_id: item.item_id,
					quantity: quantity,
					unit_price: unit_price,
					amount: quantity * unit_price,
					last_price: item.last_net_price,
					discount_amount: discount_amount,
				});
			}
		}
	} else {
		return {
			data: null,
			msg: 'No Items Matching Shopify Order.',
		};
	}

	return {
		data: invoice_items,
	};
}

function converShopifyShipment(shopify_order) {
	let shipment = null;
	if (shopify_order.shippingAddress) {
		shipment = {
			ship_to_name: shopify_order.shippingAddress.name || '',
			address_detail: shopify_order.shippingAddress.address1 || shopify_order.shippingAddress.address2 || '',
			address_detail2: shopify_order.shippingAddress.address1 ? shopify_order.shippingAddress.address2 || '' : '',
			address_city: shopify_order.shippingAddress.city || '',
			address_state: shopify_order.shippingAddress.provinceCode || '',
			address_zipcode: shopify_order.shippingAddress.zip || '',
			address_country: shopify_order.shippingAddress.countryCodeV2 || '',
			telephone: shopify_order.shippingAddress.phone || '',
		};
	}

	return {
		data: shipment,
	};
}
